import qs from 'qs'
import type { Response } from '@src/interface/api/response.interface'
import type { InitLoggedInData, InitLoggedInDataPayLoad } from '@src/lib/api/auth/types'
import client from '@src/lib/api/client'

export interface InitLoggedInDataResponse extends Response {
	data: { vendor: InitLoggedInData }
}

export const initLoggedInData = async ({
	no,
	queryData,
}: InitLoggedInDataPayLoad): Promise<InitLoggedInDataResponse> => {
	const queryString = qs.stringify(queryData)
	const response = await client.get<InitLoggedInDataResponse>(`vendors/${no}?${queryString}`)

	return response.data
}
